import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const EskerDiscrepancyDomesticStepConfig: StepConfig = {
    type: FormType.ESKER_DISCREPANCY_DOMESTIC
};
